import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import s from './Description.css';
import Button from '../../../common/components/Button/Button';

export default function Description({ jobDescription, isMobile }) {
  useStyles(s);
  return (
    <div className={`${s.descriptionContainer} ${jobDescription && jobDescription.locale === 'FA' ? s.rtl : ''}`}>
      <div>
        <h1 className={s.title}>{jobDescription && jobDescription.title}</h1>
        <p className={s.subTitle}>
          {jobDescription && `${jobDescription.city?.title || '-'} | ${jobDescription.team?.title || '-'}`}
        </p>
        {jobDescription?.responsibility && (
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(jobDescription.responsibility) }} />
        )}
        {jobDescription?.requirement && (
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(jobDescription?.requirement) }} />
        )}
      </div>
      {jobDescription && (
        <div className={`${jobDescription && jobDescription.locale === 'FA' ? s.rtlButtonContainer : s.buttonContainer}`}>
          <Button fullWidth={isMobile} onClick={() => window.open(jobDescription.submitUrl, '_blank')}>
            {jobDescription.locale !== 'FA' ? 'Apply for this job' : 'ارسال درخواست'}
          </Button>
        </div>
      )}
    </div>
  );
}

Description.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  jobDescription: PropTypes.object.isRequired,
};
